import React, { useEffect, useState } from 'react';
import { controlAPI, ControlHistoryPoint } from '../../services/api';
import { TH, LineChart, PANEL, PANEL_HDR } from './common';

// /control/training — PPO 训练收敛曲线
export default function ControlTrainingPage() {
  const [h, setH] = useState<ControlHistoryPoint[] | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    controlAPI.history().then((r) => setH(r.data)).catch(() => setErr('尚无训练历史, 请先 python manage.py train_control'));
  }, []);

  const it = h?.map((p) => p.iter) ?? [];
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: TH.bg, fontFamily: 'inherit' }}>
      <div style={{ padding: '8px 20px', borderBottom: `1px solid ${TH.headerBorder}`, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: TH.text }}>自适应调控 · 训练过程</span>
        <span style={{ fontSize: 12, color: TH.textMuted }}>PPO (Actor-Critic, 纯 NumPy 实现) 收敛曲线</span>
      </div>
      {err ? <div style={{ padding: 40, color: TH.textSec }}>{err}</div> : !h ? <div style={{ padding: 40, color: TH.textSec }}>加载中…</div> : (
        <div style={{ flex: 1, overflow: 'auto', padding: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 12, alignContent: 'start' }}>
          <div style={PANEL}><LineChart title="平均回合奖励" xlabel="训练轮次" height={220}
            series={[{ x: it, y: h.map((p) => p.reward), color: TH.rl, label: 'reward' }]} /></div>
          <div style={PANEL}><LineChart title="砂堵率" xlabel="训练轮次" height={220}
            series={[{ x: it, y: h.map((p) => p.screenout * 100), color: TH.warn, label: '砂堵率%' }]} /></div>
          <div style={PANEL}><LineChart title="支撑半缝长 (m)" xlabel="训练轮次" height={220}
            series={[{ x: it, y: h.map((p) => p.propped_len), color: TH.ok, label: 'Lp' }]} /></div>
          <div style={PANEL}><LineChart title="铺砂量 (t)" xlabel="训练轮次" height={220}
            series={[{ x: it, y: h.map((p) => p.proppant / 1000), color: TH.base, label: '铺砂' }]} /></div>
          <div style={{ ...PANEL, gridColumn: '1 / -1', padding: 12, fontSize: 12, color: TH.textMuted, lineHeight: 1.7 }}>
            <b style={{ color: TH.text }}>算法</b>: PPO (裁剪目标 + GAE + 熵正则), Actor / Critic 各一个 2 层 tanh MLP, 手写前向/反向 + Adam, 纯 NumPy 无 torch。
            训练在随机采样的地层场景池上进行 (泛化), 约 250 轮即收敛。可见奖励上升的同时砂堵率降到低位、支撑缝长与铺砂量持续提升——
            智能体学会了"多铺砂但不砂堵"的调控策略。重训: <code style={{ fontFamily: TH.fontMono }}>manage.py train_control --iters 300</code>。
          </div>
        </div>
      )}
    </div>
  );
}
